import { AttributesMixin, define, type } from "@type-r/models";
import { FilterModel, SelectMulti } from "lqx-react/lib";

import * as React from 'react';
export interface MultiSelectFilter extends AttributesMixin<typeof MultiSelectFilter> {}
@define
export class MultiSelectFilter extends FilterModel {
    static attributes = {
        ...FilterModel.attributes,
        options : [String],
        selected : type([String]).required,
        isDone : type(Boolean).check(function(x) { return x && this.selected && this.selected.length; })
    }

    delete() {
        this.$.selected.set(undefined);
        this.$.isDone.set(false);
    }

    asLabel() {
        return this.selected.length > 1 ? `Selected ${this.selected.length}` : this.selected[0];
    }

    asTitle() {
        return this.selected.map(x => x).join();
    }
}

export const EnterMultiSelect = ({ onEnter, filterValue }) => {

    return (
        <SelectMulti
            options={filterValue.options}
            $selected={filterValue.$.selected}
            onMenuClosed={() => {
                if (filterValue.selected && filterValue.selected.length) {
                    filterValue.$.isDone.set(true);
                    onEnter(filterValue.clone());
                }
            }}
        />
    )
}